import { gql } from "urql";
export const CreatePublicWebsiteLeadMutation = gql `
    mutation CreatePublicWebsiteLead($input: PublicUnifiedPriorityEntryInput!) {
        websiteLeads {
            createWebsiteLead(input: $input) {
                success
            }
        }
    }
`;
